import { pluralizeWithCount } from "@common/helpers/string";
import { ScheduleApplicationRelatedLink } from "@common/schemas/domains/accounting/scheduleApplicationList.schema";

const GO_TO_LABELS: Record<ScheduleApplicationRelatedLink["type"], string> = {
    invoice: "Go to invoice",
    bill: "Go to bill",
    transaction: "Go to transaction",
};

export function formatRelatedLinksCount(
    links: readonly ScheduleApplicationRelatedLink[],
): string {
    const types = new Set(links.map((link) => link.type));
    const noun = types.size === 1 ? [...types][0] : "match";
    return pluralizeWithCount(noun, links.length);
}

export function getRelatedLinkGoToLabel(
    link: Pick<ScheduleApplicationRelatedLink, "type">,
): string {
    return GO_TO_LABELS[link.type];
}

export function collectRelatedLinkEntityIds(
    links: readonly ScheduleApplicationRelatedLink[],
): number[] {
    return [...new Set(links.map((link) => link.entityId))];
}
